import { useDispatch, useSelector } from 'react-redux'
import { apiGet } from 'tennders-stracture/libs/api'
import { REDUX_PROMPT_TYPES } from 'tennders-common/stores/prompt/action'

const useMailTemplate = () => {
  const dispatch = useDispatch()
  const mailtemplate = useSelector((state) => state.prompt.mailtemplate)
  const setmailtemplate = (template) => dispatch({
    type: REDUX_PROMPT_TYPES.MAIL_TEMPLATE,
    payload: template
  })

  const prepareEmailTemplate = async (id, transaction) => {
    const response = await apiGet(`mails/template/${id}`)
    // @todo handle check for response
    setmailtemplate({ template: response, transaction })
  }

  return {
    mailtransaction: mailtemplate && mailtemplate.transaction,
    mailtemplate: mailtemplate && mailtemplate.template,
    setmailtemplate,
    prepareEmailTemplate
  }
}

export default useMailTemplate
